import React from 'react';
import { B1, H1, getTranslatedText, hourGlass } from '@nile/components';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';
const EmptyDataWrap = styled.div`
   {
    width: ${(props) => (props.boxWidth ? props.boxWidth : '360px')};
  }
`;

const HourGlassLoader = (props) => {
  const { intl, alignBoxCenter = false } = props;
  return (
    <div className="mb25">
      <div
        className={`fx jctr aend ${alignBoxCenter ? 'align-box-center' : ''}`}
      >
        <EmptyDataWrap
          className="empty-data-container empty-data-wrap"
          boxWidth={props.boxWidth}
        >
          <div className="progress-img">
            <img src={props.imageURL} alt="loading" width="24px"></img>
          </div>
          <p className="text progress-text-wrap empty-state-msg">
            {props.heading
              ? props.heading
              : getTranslatedText(intl, 'common.noDataFound')}
          </p>
        </EmptyDataWrap>
      </div>
    </div>
  );
};

export default injectIntl(HourGlassLoader);
